import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/home/HeroSection";
import { IntroSection } from "@/components/home/IntroSection";
import { HowIHelpSection } from "@/components/home/HowIHelpSection";
import { DestinationsSection } from "@/components/home/DestinationsSection";
import { ReassuranceSection } from "@/components/home/ReassuranceSection";
import { CTASection } from "@/components/home/CTASection";
import { Footer } from "@/components/Footer";
import SEO from "@/components/SEO";

const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  name: "Peacefully Ever After Travels",
  description:
    "Expert Walt Disney World vacation planning for families who want a structured, stress-free experience. Specializing in Magic Kingdom, Disney Cruise Line, Universal Orlando, and all-inclusive resorts.",
  url: "https://peacefullyeveraftertravel.com",
  address: {
    "@type": "PostalAddress",
    addressRegion: "GA",
    addressCountry: "US",
  },
  areaServed: "United States",
  priceRange: "Free planning service",
};

const Home = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        canonical="/"
        jsonLd={localBusinessJsonLd}
      />
      <Navigation />
      <HeroSection />
      <IntroSection />
      <HowIHelpSection />
      <DestinationsSection />
      <ReassuranceSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Home;
